import { render, staticRenderFns } from "./BoardColumns.vue?vue&type=template&id=705f8e0a&"
import script from "./BoardColumns.vue?vue&type=script&lang=js&"
export * from "./BoardColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports